export default "__VITE_ASSET__DNTT4Pyq__"